import { createSelector } from 'reselect';

const getPlayIndexHelper = (state) => {
    const {
        views: {
            isPlay,
            atBatIndex
        } = {}
    } = state;
    const hasPlayIndex = (typeof atBatIndex !== 'undefined' && atBatIndex !== '');
    return (isPlay && hasPlayIndex) ? atBatIndex : undefined;
};

export const getPlayIndex = createSelector(
    [getPlayIndexHelper],
    (playIndex) => (playIndex)
);
